import { Route, Routes } from 'react-router';
import Home from '../modules/home';
import Analytics from '../modules/analytics';
import CCS0001 from '../modules/ccs0001';
import CCS0011 from '../modules/ccs0011';
import Ajud from '../modules/ajud';
import AjudWhitelist from '../modules/ajudWhitelist';
import CCS0003 from '../modules/ccs0003';
import ReportBlocked from '../modules/reportBlocked';
import AjudMonitoring from '../modules/ajudMonitoring';
import Profile from '../modules/profile';

const LoggedRoutes = () => (
  <Routes>
    <Route path='*' element={<Home />} />
    <Route path='/ccs0001' element={<CCS0001 />} />
    <Route path='/ccs0003' element={<CCS0003 />} />
    <Route path='/ccs0011' element={<CCS0011 />} />
    <Route path='/ajud' element={<Ajud />} />
    <Route path='/analytics' element={<Analytics />} />
    <Route path='/ajudWhitelist' element={<AjudWhitelist />} />
    <Route path='/ajudMonitoring' element={<AjudMonitoring />} />
    <Route path='/reportBlocked' element={<ReportBlocked />} />
    <Route path='/profile' element={<Profile />} />
  </Routes>
)
export default LoggedRoutes;